export default {
  hero_badge: 'Professional Insulation Services',
  hero_title: 'High-Quality Insulation Solutions for Homes and Businesses',
  hero_desc: 'FMO LLC specializes in spray foam, batt, cellulose, blown-in, attic, wall, and crawl space insulation. Over 15 years of experience improving energy efficiency and comfort in Lafayette, Indiana.',
  hero_location: 'LAFAYETTE, INDIANA',
  hero_local: 'Trusted Local',
  hero_flexible: 'FLEXIBLE SCHEDULE',
  hero_flexible_sub: 'Mon-Sun Available',
  hero_free_quote: 'FREE QUOTES',
  hero_free_quote_sub: 'No Commitment',
  hero_stat_years: 'Years of Experience',
  hero_stat_satisfaction: '',
  hero_stat_free: 'Terms and Conditions Apply',
  hero_stat_local: 'Family Owned Local',
  hero_form_title: 'Get Your Free Quote Today! \uD83D\uDC47',
  hero_form_subtitle: 'We will respond quickly',
  hero_placeholder_name: 'Enter your full name',
  hero_placeholder_email: 'Enter your email address',
  hero_placeholder_phone: 'Enter your phone number',
  hero_submit: 'Request Free Quote',

  stats_experience: 'Years of Experience',
  stats_experience_desc: 'Over 15 years of experience in residential and commercial insulation.',
  stats_satisfaction: 'Satisfaction Guaranteed',
  stats_satisfaction_desc: 'Customer satisfaction guaranteed on every insulation project.',
  stats_free: 'Free Estimates',
  stats_free_word: 'Free',
  stats_free_desc: 'Free estimates with no commitment. Get your personalized quote today.',
  stats_local: 'Family Owned Local',
  stats_local_word: 'Local',
  stats_local_desc: 'Locally owned in Lafayette, Indiana. We are your neighbors.',

  about_badge: 'About Us',
  about_title: 'A Company Built on Quality Insulation and Customer Trust',
  about_desc1: 'With over 15 years of experience, FMO LLC specializes in high-quality insulation solutions for residential and commercial properties. Our team is committed to improving energy efficiency, indoor comfort, and long-term building performance through professional installation and premium materials.',
  about_desc2: 'We take pride in delivering reliable workmanship, honest service, and lasting results on every project. Whether it is new construction, renovation, or a metal building, we apply the same dedication and expertise to ensure your property is properly insulated.',
  about_serving: 'Serving Lafayette, Indiana and surrounding communities.',
  about_service_spray: 'Spray Foam Insulation',
  about_service_batt: 'Batt and Roll Insulation',
  about_service_attic: 'Attic and Wall Insulation',
  about_service_commercial: 'Commercial Insulation',

  cta_badge: 'Request Your Free Quote Today',
  cta_title: 'Good Insulation Saves Energy and Money',
  cta_desc: 'Let FMO LLC handle your insulation needs so you can enjoy greater comfort, lower energy bills, and better indoor air quality. We serve homes and businesses throughout Lafayette, Indiana and surrounding areas.',

  services_badge: 'Our Services',
  services_title: 'Complete Insulation Solutions for Every Property',
  services_desc: 'We offer a full range of insulation services for residential and commercial properties in Lafayette, Indiana and surrounding areas.',
  services_area_title: 'Local',
  services_area_label: 'Service Area',
  services_area_sub: 'Lafayette, Indiana and Surrounding Communities',
  services_section_title: 'Our Professional Insulation Services',
  services_section_desc: 'From spray foam to batt insulation, we have your property covered for maximum energy efficiency.',
  services_card1_title: 'Spray Foam Insulation',
  services_card1_desc: 'Closed cell and open cell spray foam insulation for maximum energy efficiency, air sealing, and moisture control. Ideal for attics, walls, crawl spaces, and metal buildings.',
  services_card2_title: 'Batt and Roll Insulation',
  services_card2_desc: 'Traditional fiberglass batt and roll insulation for walls, attics, and floors. Affordable, quick to install, and perfect for standard structure applications in residential and commercial buildings.',
  services_card3_title: 'Cellulose and Blown-In Insulation',
  services_card3_desc: 'Eco-friendly cellulose and blown-in insulation, perfect for attics and existing wall cavities. Excellent coverage, sound dampening, and fire-resistant properties for lasting performance.',
  services_overlay_reliable: 'Reliable and Professional',
  services_overlay_reliable_desc: 'Licensed, insured, and trained professionals on every job.',
  services_overlay_free: 'Free Estimates',
  services_overlay_free_desc: 'Contact us today for a free no-obligation estimate.',

  whyus_badge: 'Why Choose Us',
  whyus_title: 'Our Promise: Better Comfort, Lower Bills',
  whyus_desc: 'FMO LLC delivers consistent, high-quality insulation services with a focus on energy efficiency and customer satisfaction. We prioritize reliability, punctuality, and treating every property with the care it deserves.',
  whyus_bar_customer: 'Customer Satisfaction',
  whyus_bar_timely: 'Projects Completed On Time',
  whyus_bar_reliable: 'Service Reliability',
  whyus_bar_quality: 'Quality Results',

  how_badge: 'How It Works',
  how_title: 'Your Insulation Project in 4 Simple Steps',
  how_step1_title: 'Contact Us',
  how_step1_desc: 'Reach out by phone, email, or our online form. Tell us about your property and insulation needs. We are ready to help and respond quickly.',
  how_step2_title: 'Free Evaluation and Quote',
  how_step2_desc: 'We visit your property, evaluate your current insulation, and provide a clear, fair quote. No hidden fees, no surprises \u2014 just honest pricing.',
  how_step3_title: 'Professional Installation',
  how_step3_desc: 'Our team arrives on time with professional equipment. We install spray foam, batt, or blown-in insulation \u2014 delivering excellent results on every project.',
  how_step4_title: 'Inspection and Warranty',
  how_step4_desc: 'We carefully inspect every detail to ensure a perfect result. Your satisfaction is our priority. If something is not right, we come back and fix it at no extra cost.',

  reviews_google: 'Google Reviews',
  reviews_google_sub: 'Verified reviews from real customers',
  reviews_title: 'What Our Customers Say',
  reviews_desc: 'Real reviews from property owners and businesses in Lafayette, Indiana. We are proud of our reputation.',
  reviews_rating: 'out of 5 stars',
  reviews_verified: 'verified reviews',
  reviews_leave: 'Leave Us a 5-Star Review on Google',
  reviews_client1_name: 'Juan D.',
  reviews_client1_date: 'Verified Customer \u00B7 June 2026',
  reviews_client1_text: 'FMO LLC did an incredible job insulating our attic with spray foam. Our energy bills dropped significantly and the house feels much more comfortable. The team was professional, on time, and left everything spotless. Highly recommended!',
  reviews_client2_name: 'Sara M.',
  reviews_client2_date: 'Verified Customer \u00B7 May 2026',
  reviews_client2_text: 'We hired FMO for batt insulation in our new garage workshop. The price was competitive and the installation flawless. They explained everything clearly and finished ahead of schedule. We will definitely use them again for our home.',
  reviews_client3_name: 'Roberto K.',
  reviews_client3_date: 'Verified Customer \u00B7 April 2026',
  reviews_client3_text: 'The blown-in cellulose insulation they installed in our attic made a huge difference. No more drafts in winter! The team was courteous, efficient, and the free quote process was very straightforward. Excellent company.',
  reviews_client4_name: 'Laura T.',
  reviews_client4_date: 'Verified Customer \u00B7 March 2026',
  reviews_client4_text: 'FMO insulated our metal building and the results are incredible. The temperature stays consistent now and we are saving on heating costs. Professional service from start to finish. Five stars without hesitation.',
  reviews_client5_name: 'Miguel P.',
  reviews_client5_date: 'Verified Customer \u00B7 February 2026',
  reviews_client5_text: 'They insulated the crawl space under our house with FMO and I could not be happier. The moisture problems disappeared and the upper floors are much warmer. Fair price and excellent workmanship. I recommend them to all my neighbors.',
  reviews_client6_name: 'Ana W.',
  reviews_client6_date: 'Verified Customer \u00B7 January 2026',
  reviews_client6_text: 'FMO LLC insulated our entire commercial office building. They worked around our schedule, minimized disruptions, and the energy savings have been remarkable. Professional, reliable, and great value.',
  reviews_client7_name: 'Bruno R.',
  reviews_client7_date: 'Verified Customer \u00B7 December 2025',
  reviews_client7_text: 'The wall insulation project for our old home was handled perfectly by FMO. They found solutions for our unique structure and the installation was meticulous. Our house is finally warm in winter and cool in summer.',
  reviews_client8_name: 'Jessica C.',
  reviews_client8_date: 'Verified Customer \u00B7 November 2025',
  reviews_client8_text: 'From the free quote to the final inspection, FMO was top-notch. They installed closed cell spray foam in our crawl space and transformed the area. No more cold, damp crawl space. Worth every penny.',
  reviews_client9_name: 'David W.',
  reviews_client9_date: 'Verified Customer \u00B7 October 2025',
  reviews_client9_text: 'We have used FMO for two properties and they always deliver excellent results. Their attention to detail, competitive pricing, and customer service set them apart. The best insulation contractor in Lafayette.',

  finalcta_badge: 'Your Comfort. Our Commitment. Every Season.',
  finalcta_title: 'Invest in Your Property Comfort',
  finalcta_desc: 'Good insulation brings more than just comfort \u2014 it brings energy savings, better air quality, and increased property value. FMO LLC is ready to transform your home or business in Lafayette, Indiana.',
};